import "./instrument.ts";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";

import App from "./App.tsx";
import "@/lib/i18n";
import { QueryClientProvider } from "@tanstack/react-query";
// import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { queryClient } from "./api/config/query-client";
import { GrowthBookProvider } from "@growthbook/growthbook-react";
import { gb, initGrowthBook } from "@/lib/growthbook";
// import { MaintenanceMode } from "./components/ui/maintenance-mode.tsx";

// Sohbet→modül eşlemesi artık sunucuda (`conversation.module`); eski istemci
// haritası ölü veri. Birkaç sürüm sonra bu satır kaldırılabilir.
try {
  localStorage.removeItem("chat-module-storage");
} catch {
  // Storage erişimi kapalı (private mode / izin yok) — önemli değil
}

// Render'dan önce beklemek bilinçli: flag'ler route guard kararı veriyor
// (persona/onboarding), ilk boyamadan sonra değişirlerse kullanıcı açılmış bir
// sayfadan atılır. Payload localStorage'da cache'lendiği için dönen kullanıcıda
// anında çözülür; ilk ziyarette maliyet timeout ile sınırlı ve süre dolarsa
// uygulama fallback'lerle — yani bugünkü davranışıyla — normal şekilde açılır.
//
// Top-level await DEĞİL: build hedefi (es2020/safari14) desteklemiyor ve bunun
// için tüm tarayıcıların çıktısını değiştirmeye değmez. `finally` de bilerek —
// `initGrowthBook` kendi içinde hata yutuyor ama ileride yutmayı bırakırsa bile
// uygulamanın açılmaması bir seçenek olmamalı.
initGrowthBook().finally(() => {
  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <GrowthBookProvider growthbook={gb}>
          <App />
        </GrowthBookProvider>
        {/* <ReactQueryDevtools initialIsOpen={false} /> */}
        {/* <MaintenanceMode /> */}
      </QueryClientProvider>
    </React.StrictMode>,
  );
});
